import styled from 'styled-components';
const StyledH3 = styled.h3 `
    position: relative;
    font-family: ${props => props.theme.fontHead};
    color: ${props => props.theme.primary.base};
    font-weight: 700;
    margin-bottom: 15px;
    padding-bottom: 8px;
    font-size: 18px;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background-color: ${props => props.theme.headingHighlight};
        border-radius: 1px;
    }

    @media only screen and (min-width: 1260px) {
        font-size: 20px;
    }
`;
export default StyledH3;
